import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API_URL = import.meta.env.VITE_API_URL || '';

const DeleteAccountPage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [reason, setReason] = useState('');
  const [confirmTyping, setConfirmTyping] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!user) {
    return (
      <div style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        color: '#aaa',
      }}>
        <p style={{ fontSize: '18px' }}>Для удаления аккаунта необходимо войти.</p>
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
            border: 'none',
            padding: '12px 32px',
            borderRadius: '10px',
            color: '#0a0a1a',
            fontSize: '16px',
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: '16px',
          }}
        >
          На главную
        </button>
      </div>
    );
  }

  const handleDelete = async () => {
    if (confirmTyping !== 'УДАЛИТЬ') {
      setError('Введите "УДАЛИТЬ" для подтверждения');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/api/account/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // HttpOnly cookies (фаза 1.1)
        body: JSON.stringify({ confirm: true, reason: reason || undefined }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
        // Очистка legacy-токенов (cookies очистит сервер при следующем запросе)
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
      } else {
        setError(data.message || 'Ошибка удаления аккаунта');
      }
    } catch (err: any) {
      setError(err.message || 'Ошибка соединения');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{
        maxWidth: '600px',
        margin: '80px auto',
        padding: '40px',
        textAlign: 'center',
      }}>
        <div style={{
          background: 'rgba(13, 20, 40, 0.85)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(212, 175, 55, 0.12)',
          borderRadius: '24px',
          padding: '48px 40px',
          boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
          position: 'relative',
        }}>
          <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>👋</div>
          <h2 style={{
            color: '#d4af37',
            fontSize: '28px',
            fontFamily: 'var(--font-display)',
            marginBottom: '16px',
          }}>
            Аккаунт удалён
          </h2>
          <p style={{ color: '#aaa', fontSize: '16px', lineHeight: 1.7, marginBottom: '32px' }}>
            Ваш аккаунт и все связанные данные были удалены. Мы сожалеем о вашем уходе.
          </p>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
              border: 'none',
              padding: '14px 40px',
              borderRadius: '12px',
              color: '#0a0a1a',
              fontSize: '16px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            На главную
          </button>
        </div>
      </div>
    );
  }

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '16px',
    boxSizing: 'border-box',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#d4af37',
    marginBottom: '8px',
    fontSize: '14px',
  };

  return (
    <div style={{
      maxWidth: '600px',
      margin: '40px auto',
      padding: '0 20px 80px',
    }}>
      <div style={{
        background: 'rgba(13, 20, 40, 0.85)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(220, 53, 69, 0.4)',
        borderRadius: '24px',
        padding: '40px',
        boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
        position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />
        {/* Warning header */}
        <div style={{
          background: 'rgba(220, 53, 69, 0.15)',
          border: '1px solid rgba(220, 53, 69, 0.4)',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '28px',
          textAlign: 'center',
        }}>
          <span style={{ fontSize: '24px' }}>⚠️</span>
          <h2 style={{
            color: '#dc3545',
            fontSize: '22px',
            fontFamily: 'var(--font-display)',
            marginBottom: '8px',
          }}>
            Удаление аккаунта
          </h2>
          <p style={{ color: '#dc3545', fontSize: '14px', margin: 0 }}>
            Это действие нельзя отменить. Все ваши данные будут удалены навсегда.
          </p>
        </div>

        {/* What will be deleted */}
        <div style={{ marginBottom: '28px' }}>
          <h3 style={{ color: '#d4af37', fontSize: '18px', marginBottom: '12px' }}>
            Что будет удалено:
          </h3>
          <ul style={{ color: '#aaa', fontSize: '14px', lineHeight: 2, paddingLeft: '20px' }}>
            <li>Профиль и персональные данные</li>
            <li>Все расчёты и прогнозы</li>
            <li>Контакты и данные о совместимости</li>
            <li>Активная подписка (будет отменена)</li>
            <li>Описания и история действий</li>
          </ul>
        </div>

        {/* Reason */}
        <div style={{ marginBottom: '24px' }}>
          <label style={labelStyle}>
            Причина удаления (необязательно)
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Расскажите, почему вы уходите..."
            rows={3}
            style={{ ...inputStyle, resize: 'vertical', minHeight: '80px' }}
          />
        </div>

        {/* Confirmation */}
        <div style={{ marginBottom: '24px' }}>
          <label style={labelStyle}>
            Для подтверждения введите <strong>УДАЛИТЬ</strong>:
          </label>
          <input
            type="text"
            value={confirmTyping}
            onChange={(e) => setConfirmTyping(e.target.value)}
            placeholder="УДАЛИТЬ"
            style={{
              ...inputStyle,
              borderColor: confirmTyping === 'УДАЛИТЬ'
                ? 'rgba(79, 209, 197, 0.5)'
                : 'rgba(220, 53, 69, 0.5)',
            }}
          />
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background: 'rgba(220, 53, 69, 0.2)',
            border: '1px solid #dc3545',
            borderRadius: '10px',
            padding: '12px',
            marginBottom: '20px',
            color: '#dc3545',
            textAlign: 'center',
            fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        {/* Delete button */}
        <button
          onClick={handleDelete}
          disabled={loading || confirmTyping !== 'УДАЛИТЬ'}
          style={{
            width: '100%',
            padding: '15px',
            background: (loading || confirmTyping !== 'УДАЛИТЬ')
              ? '#555'
              : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
            border: 'none',
            borderRadius: '12px',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: (loading || confirmTyping !== 'УДАЛИТЬ') ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s',
          }}
        >
          {loading ? 'Удаление...' : 'Удалить аккаунт навсегда'}
        </button>

        {/* Cancel link */}
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => navigate('/profile')}
            style={{
              background: 'none',
              border: 'none',
              color: '#4fd1c5',
              cursor: 'pointer',
              fontSize: '14px',
              textDecoration: 'underline',
            }}
          >
            ← Вернуться в профиль
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
